module.exports = __webpack_public_path__ + "static/media/pic_03.b74542d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageTextCheck/pic_03.png
// module id = 594
// module chunks = 0